import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import { useAuth } from "../../contexts/auth";
import { postOrdersURL, getSearchProductsURL } from "../../utils/api";
// Chakra imports
import {
    Box,
    Button,
    Flex,
    Icon,
    Spacer,
    Text,
    useColorModeValue,
    FormControl,
    FormLabel,
    Select,
    Input,
    Progress,
    Switch,
    useDisclosure,
    Alert,
    AlertIcon,
} from "@chakra-ui/react";
import { Separator } from "components/Separator/Separator";
// react icons
import { BsArrowRight } from "react-icons/bs";
import useGetCustomers from "../../hooks/useGetCustomers";
import useGetServices from "../../hooks/useGetServices";
import useGetMechanics from "hooks/useGetMechanics";
import CustomizeService from "./CustomizeService";
import ViewEstimate from "../../modals/ViewEstimate";
import CreateOrder from "../../modals/CreateOrder";

function CreateEstimate() {
    const textColor = useColorModeValue("gray.700", "white");
    const bgButton = useColorModeValue(
      "linear-gradient(81.62deg, #313860 2.25%, #151928 79.87%)",
      "gray.800"
    );

    const { isOpen: isOpenCreate, onOpen: onOpenCreate, onClose: onCloseCreate } = useDisclosure();
    const { isOpen: isOpenViewEstimate, onOpen: onOpenViewEstimate, onClose: onCloseViewEstimate } = useDisclosure();
    const [ orderData, setOrderData ] = useState(null);

    const [ carMake, setCarMake ] = useState('');
    const [ carType, setCarType ] = useState('');
    const [ carYear, setCarYear ] = useState('');
    const [ carPlate, setCarPlate ] = useState('');
    const [ carOdometer, setCarOdometer ] = useState('');
    const [ orderServices, setOrderServices ] = useState([]);
    const [ orderMechanics, setOrderMechanics ] = useState([]);
    // const [ workingDays, setWorkingDays ] = useState('1');

    let { services, setGettingServices, gettingServices, gettingServicesReqSuccess } = useGetServices({ page: 1, limit: 3000 });
    let { mechanics, setGettingMechanics, gettingMechanics, gettingMechanicsReqSuccess } = useGetMechanics({ page: 1, limit: 3000 });



    const onToggleService = (service, checked) => {
        const orderServicesIds = orderServices.map(s => s.id);
        
        if (checked && !orderServicesIds.includes(service.id)) {
            const tmp = [...orderServices];
            const tmpService = {
                ...service,
                addedProducts: service.completeProducts.map(product => {
                    return {
                        id: product.id,
                        name: product.name,
                        sku: product.sku,
                        price: 0,
                        quantity: 1,
                    }
                })
            }
            tmp.push(tmpService);
            setOrderServices(tmp);
            // console.log(tmp);
        } else if (!checked && orderServicesIds.includes(service.id)) {
            const tmp = orderServices.filter(os => os.id !== service.id);
            setOrderServices(tmp);
            // console.log(tmp);
        }

    }

    const onToggleMechanic = (mechanic, checked) => {
        const orderMechanicsIds = orderMechanics.map(s => s.id);
        
        if (checked && !orderMechanicsIds.includes(mechanic.id)) {
            const tmp = [...orderMechanics];
            const tmpMechanic = {
                ...mechanic
            }
            tmp.push(tmpMechanic);
            setOrderMechanics(tmp);
            // console.log(tmp);
        } else if (!checked && orderMechanicsIds.includes(mechanic.id)) {
            const tmp = orderMechanics.filter(os => os.id !== mechanic.id);
            setOrderMechanics(tmp);
            // console.log(tmp);
        }

    }

    const onAddedServiceUpdate = (service) => {
        const tmp = [...orderServices];
        tmp.forEach((s, index) => {
            if (s.id == service.id) {
                tmp[index] = service;
            }
        });
        setOrderServices(tmp);
        // console.log(service);
    }



    const onAddedMechanicUpdate = (mechanic) => {
        const tmp = [...orderMechanics];
        tmp.forEach((s, index) => {
            if (s.id == mechanic.id) {
                tmp[index] = mechanic;
            }
        });
        setOrderMechanics(tmp);
        // console.log(service);
    }


    useEffect(() => {
        setGettingServices(true);
        setGettingMechanics(true);
    }, []);

    useEffect(() => {
        if (
            carMake != '' &&
            carType != '' &&
            carYear != '' &&
            carPlate != '' &&
            carOdometer != '' &&
            // orderServices != '' &&
            // workingDays != '' &&
            orderServices.length > 0,
            orderMechanics.length > 0
        ) {
            setOrderData({
                carMake: carMake,
                carType: carType,
                carYear: carYear,
                carPlate: carPlate,
                carOdometer: carOdometer,
                // workingDays: workingDays,
                orderServices: orderServices,
                orderMechanics: orderMechanics,
            });
        }

    }, 
    [ carMake,
        carType,
        carYear,
        carPlate,
        carOdometer,
        orderServices,
        orderMechanics,
        // workingDays,
    ]);

    // const showEstimate = () => {
    //     const tmp = {
    //         carMake: carMake,
    //         carType: carType,
    //         carYear: carYear,
    //         carPlate: carPlate,
    //         carOdometer: carOdometer,
    //         workingDays: workingDays,
    //         orderServices: orderServices,
    //     }

    //     setOrderData(tmp);
    //     onOpenViewEstimate(true);
    // }

    // const toBuildOrder = () => {
    //     const tmp = {
    //         carMake: carMake,
    //         carType: carType,
    //         carYear: carYear,
    //         carPlate: carPlate,
    //         carOdometer: carOdometer,
    //         workingDays: workingDays,
    //         orderServices: orderServices,
    //     }

    //     setOrderData(tmp);
    //     onOpenCreate(true);
    // }

    return (
        <>
            <Flex flexDirection="column" w="100%">
             
                <Text 
                  fontSize="lg"
                  color={textColor}
                  fontWeight="bold"
                  pb=".5rem"
                >
                  Create Estimate (Service Order)
                </Text>

                {/* Car DEtails */}
                <FormControl marginBottom="12px">
                    <Text fontSize="sm" color="gray.400" fontWeight="bold">
                        VEHICLE DETAILS
                    </Text>
                    <Flex flexDirection="row" w="100%">
                        <Box pr="12px" width={{ md: "50%", sm: "100%" }}>
                            <FormLabel ms="4px" fontSize="sm" fontWeight="normal">
                                Make
                            </FormLabel>
                            <Input
                                borderRadius="15px"
                                mb="12px"
                                fontSize="sm"
                                type="text"
                                placeholder="Toyota"
                                size="md" 
                                isRequired={true}
                                value={carMake} 
                                onChange={e => setCarMake(e.target.value)}
                            />
                        </Box>

                        <Box pr="12px" width={{ md: "50%", sm: "100%" }}>
                            <FormLabel ms="4px" fontSize="sm" fontWeight="normal">
                                Type
                            </FormLabel>
                            <Input
                                borderRadius="15px"
                                mb="12px"
                                fontSize="sm"
                                type="text"
                                placeholder="Camry"
                                size="md" 
                                isRequired={true}
                                value={carType} 
                                onChange={e => setCarType(e.target.value)}
                            />
                        </Box>

                        <Box pr="12px" width={{ md: "50%", sm: "100%" }}>
                            <FormLabel ms="4px" fontSize="sm" fontWeight="normal">
                                Year
                            </FormLabel>
                            <Input
                                borderRadius="15px"
                                mb="12px"
                                fontSize="sm"
                                type="text"
                                placeholder="2020"
                                size="md" 
                                isRequired={true}
                                value={carYear} 
                                onChange={e => setCarYear(e.target.value)}
                            />
                        </Box>
                    </Flex>

                    <Flex flexDirection="row" w="100%">

                        
                        <Box pr="12px" width={{ md: "50%", sm: "100%" }}>
                            <FormLabel ms="4px" fontSize="sm" fontWeight="normal">
                                Plate #
                            </FormLabel>
                            <Input
                                borderRadius="15px"
                                mb="12px"
                                fontSize="sm"
                                type="text"
                                placeholder="1234-ABCD"
                                size="md" 
                                isRequired={true}
                                value={carPlate} 
                                onChange={e => setCarPlate(e.target.value)}
                            />
                        </Box>

                        <Box pr="12px" width={{ md: "50%", sm: "100%" }}>
                            <FormLabel ms="4px" fontSize="sm" fontWeight="normal">
                                Odometer
                            </FormLabel>
                            <Input
                                borderRadius="15px"
                                mb="12px"
                                fontSize="sm"
                                type="text"
                                placeholder="5000"
                                size="md" 
                                isRequired={true}
                                value={carOdometer} 
                                onChange={e => setCarOdometer(e.target.value)}
                            />
                        </Box>

                    </Flex>
                </FormControl>


                 {/* Service DEtails */}
                 {/* <FormControl marginBottom="12px">
                    <Text fontSize="sm" color="gray.400" fontWeight="bold">
                        SERVICE DETAILS
                    </Text>

                    <Flex flexDirection="row" w="100%">

                        <Box pr="12px" width={{ md: "50%", sm: "100%" }}>
                            <FormLabel ms="4px" fontSize="sm" fontWeight="normal">
                                Duration (Days)
                            </FormLabel>
                            <Input
                                borderRadius="15px"
                                mb="12px"
                                fontSize="sm"
                                type="number"
                                placeholder="5000"
                                size="md" 
                                isRequired={true}
                                value={workingDays} 
                                onChange={e => setWorkingDays(e.target.value)}
                            />
                        </Box>

                    </Flex>
                </FormControl> */}


                {/* Mechanic */}
                <FormControl marginBottom="12px">
                    <FormLabel>Please Select Mechanic</FormLabel>
                    {   gettingMechanics
                        ? <Progress isIndeterminate />
                        : <Flex flexDirection="column" w="100%">
                            {   mechanics.map((mechanic, sIndex) => {
                                    return <Flex direction="column" w="100%" key={`mechanic-toggle-${sIndex}`}>
                                        <FormControl display="flex" alignItems="center">
                                            <Switch colorScheme="teal" me="10px" onChange={(e) => onToggleMechanic(mechanic, e.target.checked)}/>
                                            <FormLabel
                                                mb="0"
                                                ms="1"
                                                fontWeight="normal"
                                                >
                                                {mechanic.firstName} {mechanic.lastName}
                                            </FormLabel>
                                        </FormControl>
                                       
                                    </Flex>
                                })
                            }
                        </Flex>
                    }
                </FormControl>

                {/* Services */}
                <FormControl marginBottom="12px">
                    <FormLabel>Please Select Services</FormLabel>
                    {   gettingServices
                        ? <Progress isIndeterminate />
                        : <Flex flexDirection="column" w="100%">
                            {   services.map((service, sIndex) => {
                                    return <Flex direction="column" w="100%" key={`service-toggle-${sIndex}`}>
                                        <FormControl display="flex" alignItems="center">
                                            <Switch colorScheme="teal" me="10px" onChange={(e) => onToggleService(service, e.target.checked)}/>
                                            <FormLabel
                                                mb="0"
                                                ms="1"
                                                fontWeight="normal"
                                                >
                                                {service.title} (₱{service.discountedPrice > 0 ? service.discountedPrice : service.price})
                                            </FormLabel>
                                        </FormControl>
                                        { orderServices.filter(os => os.id == service.id).length > 0
                                            ? <CustomizeService 
                                                serviceData={service}
                                                onDataUpdated={onAddedServiceUpdate}
                                            />
                                            : null
                                        }
                                       
                                    </Flex>
                                })
                            }
                        </Flex>
                    }
                </FormControl>

                <Spacer />
                
                { orderData == null  
                    ? <Alert status="info" mb={4}><AlertIcon></AlertIcon>Complete Form to enable actions</Alert>
                    : null 
                }

                <Flex direction={"row"} justifyContent={"space-between"}>
                    <Button
                        fontSize="10px"
                        type="button"
                        bg="teal.300"
                        w="33%"
                        h="45"
                        mb="20px"
                        color="white"
                        mt="0px"
                        _hover={{
                        bg: "teal.200",
                        }}
                        _active={{
                        bg: "teal.400",
                        }}
                        disabled={orderData == null}
                        onClick={() => onOpenViewEstimate(true)}
                    >
                        VIEW SUMMARY
                    </Button>
                    
                    <Button
                        fontSize="10px"
                        type="button"
                        bg="teal.300"
                        w="33%"
                        h="45"
                        mb="20px"
                        color="white"
                        mt="0px"
                        _hover={{
                        bg: "teal.200",
                        }}
                        _active={{
                        bg: "teal.400",
                        }}
                        tool
                        disabled={orderData == null}
                        onClick={() => onOpenCreate(true)}
                    >
                        BUILD ORDER
                    </Button>
                </Flex>


            </Flex>

            <ViewEstimate 
                isOpen={isOpenViewEstimate}
                onClose={onCloseViewEstimate}
                orderData={orderData}
            />

            <CreateOrder
                isOpen={isOpenCreate}
                onClose={onCloseCreate}
                orderData={orderData} 
            />
        </>
    );
}


export default CreateEstimate;